export enum Access {
  Read = 'Read',
  Write = 'Write',
  Allowed = 'Allowed',
  None = 'None'
}

export default Access;
